export var detailsBtn = {
  padding: '0.6em',
  '& > i': {
    margin: 0
  }
};
export var canApproveText = function canApproveText(canApprove) {
  return function (theme) {
    return {
      color: canApprove ? theme.success : theme.error
    };
  };
};